import React from 'react';
import classnames from 'classnames';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { lazyImage as LazyImage } from 'modules/lazy-image';
 *
 * // render
 * <LazyImage propName='propValue'/>
 */
export const lazyImage = ( props ) => {

	const { isLoading, imageClassName, preloaderClassName, ...imageProps } = props;

	// get preloader class name
	const _preloaderClassName = classnames( 'ui-lazy-image--preloader', preloaderClassName );

	// get image class name
	const _imageClassName = classnames( 'ui-lazy-image', imageClassName );

	// display preloader view
	if( isLoading ) {
		return (
			<div
				className={ _preloaderClassName }
			/>
		);
	}

	// display real view
    return (
		<img
			className={ _imageClassName }
			{ ...imageProps }
		/>
    );
};

// set display name
lazyImage.displayName = 'lazyImage';

// set default props
lazyImage.defaultProps = {};

// prop types
lazyImage.propTypes = {};
